import { Modal } from 'antd';
import PrimaryButton from 'components/button/PrimaryButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { theme } from 'utils/style/theme';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  label?: string;
  title?: string;
  content?: string;
  handleDelete: () => Promise<void>;
  loading?: boolean;
}

const DeleteModal = ({
  visible,
  setVisible,
  label,
  title,
  handleDelete,
  loading = false,
  content = 'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCutContent.minicutDeleteModal.detailContent',
}: IProps) => {
  const { t } = useTranslation();

  /// 모달 닫기
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <CustomModal
      title={title}
      open={visible}
      centered
      onCancel={handleClose}
      footer={
        <>
          <PrimaryButton
            text={t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCutContent.minicutDeleteModal.cancel',
            )}
            height='40px'
            width='151px'
            bgColor='#ffff'
            textColor={theme.colors.dark_400}
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.gray_6}`}
            rounded='6px'
            hoverBgColor='#ffff'
            activeBgColor='#ffff'
            selectedBgColor='#ffff'
            onClick={handleClose}
          />
          <PrimaryButton
            text={t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCutContent.minicutDeleteModal.confirm',
            )}
            height='40px'
            width='151px'
            bgColor={theme.colors.red_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.red_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.red_500}
            activeBgColor={theme.colors.red_500}
            selectedBgColor={theme.colors.red_500}
            onClick={handleDelete}
            loading={loading}
            disabled={loading}
          />
        </>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <p className='name'>{label}</p>
      <p className='content'>{t(content)}</p>
    </CustomModal>
  );
};

export default DeleteModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    display: flex;
    justify-content: end;
    column-gap: 12px;
    margin-top: 16px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
  .name {
    font-size: ${theme.fontSizes.base};
    font-weight: ${theme.fontWeights.bold};
    line-height: 28px;
    letter-spacing: 0.1px;
    text-align: center;
    color: ${theme.colors.dark_500};
  }
  .content {
    margin-top: 16px;
    font-size: ${theme.fontSizes.normal};
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
`;
